import { InvestmentPackageSettings } from 'api-client';
import { formatAmount } from 'utils';

export function amountKopecksToRub(amountKopecks: number): number {
  return Math.floor(amountKopecks / 100);
}

export function formatAmountRub(amountKopecks: number): string {
  return `${formatAmount(amountKopecksToRub(amountKopecks))} ₽`;
}

export function formatTermRange(minTerm: number | null, maxTerm: number | null): string {
  if (minTerm !== null && maxTerm !== null) {
    return `${minTerm} мес. — ${maxTerm} мес.`;
  }
  if (minTerm !== null) {
    return `от ${minTerm} мес.`;
  }
  if (maxTerm !== null) {
    return `до ${maxTerm} мес.`;
  }
  return '—';
}

export type ComfortSettingsBullet = {
  readonly beforeChip?: string;
  readonly chip?: string;
  readonly afterChip?: string;
  readonly plain?: string;
};

export function buildSettingsBullets(settings: InvestmentPackageSettings): ComfortSettingsBullet[] {
  return [
    {
      plain:
        'Счет Комфорт является инструментом автоматического управления портфелем. Каждое отдельное пополнение счета Комфорт формирует пакет из 10 сделок, распределяя размер пополнения в сделки равными частями',
    },
    {
      plain:
        'Осуществляя настройку пакета сделок, инвестор имеет возможность подключить к формируемому пакету функцию Защита Капитала',
    },
    {
      beforeChip: 'Инвестор имеет возможность осуществлять множество пополнений, формируя ',
      chip: 'множество пакетов сделок',
    },
    {
      beforeChip: 'Одно пополнение — ',
      chip: '1 пакет из 10 сделок',
    },
    {
      beforeChip: 'Минимальная сумма пополнения для формирования пакета ',
      chip: formatAmountRub(settings.minAmount),
      afterChip: ' рублей',
    },
    {
      beforeChip:
        'Начисление бонусов на нераспределенные средства до момента формирования пакета размере ',
      chip: 'ключевой ставки',
    },
    {
      plain: 'Выбор подключения функции',
      chip: 'Защита капитала',
    },
  ];
}

export function buildSettingsTableRows(
  settings: InvestmentPackageSettings
): Array<[string, string]> {
  return [
    ['Экономическая категория :', settings.economicClasses.join(', ') || '—'],
    ['Юридическая категория :', settings.legalClasses.join(', ') || '—'],
    ['Прогноз срока взыскания :', formatTermRange(settings.minTerm, settings.maxTerm)],
    ['Прогноз годовой доходности :', 'без ограничений'],
    ['Прогноз простой доходности :', 'без ограничений'],
    ['Сделки с Инкассо сессией', settings.enableIncasso ? 'применяется' : 'не применяется'],
    [
      'Повторные сделки с одним должником',
      settings.enableSameBorrower ? 'применяется' : 'не применяется',
    ],
  ];
}

export function getMinTopupKopecks(settings: InvestmentPackageSettings): number {
  return settings.minAmount;
}

export function getDealsPerPackage(settings: InvestmentPackageSettings): number {
  return settings.dealsCount;
}
